import React from 'react'
import { Switch as MuiSwitch } from '@material-ui/core'
import { styleOverride, styleOverrideWithIcon } from './style'
import { ThemeProvider } from '@material-ui/core'
import theme from '../theme'
import { SwitchPropsInterface } from './SwitchInterface'

const Switch: React.FC<SwitchPropsInterface> = React.forwardRef(
  (props, ref) => {
    const { switchText, ...cleanedProps } = props
    return (
      <ThemeProvider theme={theme}>
        <MuiSwitch
          {...cleanedProps}
          classes={
            props.checkedIcon || switchText
              ? styleOverrideWithIcon(props.color, switchText)()
              : styleOverride()
          }
        />
      </ThemeProvider>
    )
  }
)

Switch.displayName = 'Switch'

export default Switch
